/** "1 h 30 min" / "45 min" — used in calendar blocks and the all-tasks list. */
export function formatDuration(min: number): string {
  if (min <= 0) return "—";
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}

/** Compact duration for the calendar block time line: "45m" / "3h" / "1h30". */
export function formatDurationCompact(min: number): string {
  if (min <= 0) return "";
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h${pad(m)}`;
}

/** Zero-pad to 2 digits. */
export function pad(n: number): string {
  return String(n).padStart(2, "0");
}

/** Time-of-day string. `hour12` ⇒ "1:05 PM"; default 24-hour ⇒ "13:05". */
export function formatHm(hour: number, minute: number, hour12 = false): string {
  if (hour12) {
    const period = hour < 12 ? "AM" : "PM";
    const h = hour % 12 === 0 ? 12 : hour % 12;
    return `${h}:${pad(minute)} ${period}`;
  }
  return `${pad(hour)}:${pad(minute)}`;
}

/** Time-of-day from a Date's local time. `hour12` toggles 12/24-hour display. */
export function formatHmDate(d: Date, hour12 = false): string {
  return formatHm(d.getHours(), d.getMinutes(), hour12);
}

/** "lo–hi" from minutes-of-day bounds. `hour12` toggles 12/24-hour display. */
export function formatRange(loMin: number, hiMin: number, hour12 = false): string {
  return `${formatHm(Math.floor(loMin / 60), loMin % 60, hour12)}–${formatHm(Math.floor(hiMin / 60), hiMin % 60, hour12)}`;
}
